jQuery(document).ready(function ($) {
  // Akkordeon bei den Produkten
  $('[data-type="accordeon-title"]').click(function (event) {
    event.preventDefault();
    _this = this;
    $target = $(_this).next();
    $target.slideToggle();
    $(_this).toggleClass('is-open');
    if ($(_this).hasClass('is-open')) {
      accordeonScrollTo($(_this));
    }
  });

  var accordeonScrollTo = function (target) {
    var t = target;
    var $page = $('html, body');

    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
      $page.stop();
    });

    $page.animate({
      scrollTop: t.offset().top - 40,
    }, 'slow', function () {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });

    return false;
  };
});
